import { computed, inject, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useGetLink } from "./getAddForm";
import { useForm } from "@/components/Form";
import { Links } from "../data/template";
import { dailylyControlApi } from "@/api/control/dailyControl.api";
import dayjs from "dayjs";
import moment from "moment";
export function getFormPlan(props) {
  const format = "YYYY-MM-DD";
  const link = useGetLink();
  const options = reactive({
    user: [],
    template: [
      {
        label: "日管控模板",
        value: "42852754ba064ff58d6425d33fa599aa"
      }
    ]
  });
  ("link.value", link.value);
  const formSchema = computed(() => {
    const result = [
      {
        field: "pjmb",
        label: "评价模版",
        colProps: {
          span: 24
        },
        component: "Input",
        slot: "pjmb"
      },
      {
        label: "负责人",
        field: "head",

        component: "Select",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: link.value !== Links.Plan,
          options: options.user,
          required: true,
          rules: [{ required: true, message: "Please select your gender!" }]
        }
      },
      {
        label: "任务日期",
        field: "action_time",
        required: true,
        component: "DatePicker",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      },
      {
        label: "结束日期",
        field: "action_time",//"end_time",
        required: true,
        component: "DatePicker",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: true
        }
      },
      {
        label: "执行人",
        field: "executor",
        component: "Input",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      },
      {
        label: "执行日期",
        field: "check_time",
        component: "DatePicker",
        colProps: {
          span: 8
        },
        componentProps: {
          format,
          disabled: link.value !== Links.Plan
        }
      }
    ];
    if ([Links.Rectification, Links.Examine, Links.End].includes(link.value)) {
      result.push({
        label: "检查结果",
        field: "jcjg",
        component: "RadioGroup",
        componentProps: {
          disabled: link.value !== Links.Plan,
          options: [
            {
              label: "零报告",
              value: "零报告"
            },
            {
              label: "风险隐患",
              value: "风险隐患"
            }
          ]
        }
      });
      result.push({
        label: "检查说明",
        field: "jcsm",
        component: "InputTextArea",
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      });
    }
    if ([Links.Examine, Links.End].includes(link.value)) {
      result.push({
        label: "开始整改",
        field: "kszg",
        component: "DatePicker",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      });
      result.push({
        label: "整改完成",
        field: "zgwc",
        component: "DatePicker",
        colProps: {
          span: 8
        },
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      });
      result.push({
        label: "整改结果",
        field: "zgjg",
        component: "Input",
        colProps: {
          span: 8
        },
        render() {
          return "整改后待审核";
        }
      });
      result.push({
        label: "整改意见",
        field: "zgyh",
        component: "InputTextArea",
        componentProps: {
          disabled: link.value !== Links.Plan
        }
      });
    }
    return result;
  });
  // const [registerForm, { setFieldsValue, validate, resetSchema }] = useForm({
  //   labelWidth: 90,
  //   baseColProps: { span: 24 },
  //   schemas: formSchema.value,
  //   showActionButtonGroup: false
  // });
  // watch(
  //   () => formSchema.value,
  //   () => {
  //     resetSchema(formSchema.value);
  //   },
  //   {
  //     deep: true
  //   }
  // );
  
  // 先声明 formData，避免初始化顺序问题
  // 如果是编辑模式，需要将字符串日期转换为 moment 对象
  // 辅助函数：安全地转换为 moment 对象
  const toMoment = (dateValue) => {
    if (!dateValue || dateValue === '') return null;
    const m = moment(dateValue);
    return m.isValid() ? m : null;
  };
  
  const formData = ref(props.obj.id ? {
    ...props.obj,
    action_time: toMoment(props.obj.action_time),
    end_time: toMoment(props.obj.end_time),
    check_time: toMoment(props.obj.check_time),
  } : {
    pjmb: "42852754ba064ff58d6425d33fa599aa",
    head: "",
    executor: "",
    action_time: null,
    end_time: null,
    check_time: null,
  });
  
  function initFormData() {
    formData.value = {
      // state: 3,
      pjmb: "42852754ba064ff58d6425d33fa599aa",
      head: options.user[0] ? options.user[0].value : "",
      executor: "",
      action_time: moment(),
      end_time: moment(),
      check_time: moment(),
      jcjg: "风险隐患",
      jcsm: "说明说明"
    };
  }
  
  async function init() {
    // 尝试从 Vuex 缓存获取用户列表
    const store = inject('$store');
    if (store) {
      const cachedUsers = store.getters['dailyControl/getUserList'];
      if (cachedUsers && cachedUsers.length > 0) {
        // console.log('使用缓存的用户列表');
        options.user = cachedUsers;
        initFormData();
        return;
      }
    }
    
    // 缓存未命中，调用接口
    // console.log('从接口获取用户列表');
    const userData = await dailylyControlApi.getUser({
      page: 1,
      pageSize: 100000
    });
    options.user = userData.results.map(item => ({
      label: item.name,
      value: item.id
    }));
    
    // 保存到缓存
    if (store) {
      store.commit('dailyControl/setUserList', options.user);
    }
    
    initFormData();
  }
  
  if (!props.obj.id) {
    init();
  }

  async function getFormPlanData() {
    // ("formData", formData);
    // 确保日期字段是有效的 moment 对象再转换，否则使用 null
    formData.value.check_time = formData.value.check_time && moment.isMoment(formData.value.check_time) 
      ? dayjs(formData.value.check_time).format(format) 
      : formData.value.check_time || null;
    formData.value.action_time = formData.value.action_time && moment.isMoment(formData.value.action_time)
      ? dayjs(formData.value.action_time).format(format)
      : formData.value.action_time || null;
    formData.value.end_time = formData.value.action_time && moment.isMoment(formData.value.action_time)
      ? dayjs(formData.value.action_time).format(format) 
      : formData.value.action_time || null;
    return formData.value;
  }
  
  return {
    link,
    options,
    // registerForm,
    getFormPlanData,
    formData
  };
}
